
const lazyloadPicture = (pictureTag) => {
    if (pictureTag.tagName !== 'PICTURE' || !pictureTag.classList.contains('preview')) {
        return;
    }

    let sources = pictureTag.children;

    for (let i = 0; i < sources.length; i++) {
        let source = sources[i];
        if (!source.dataset.src) {
            continue;
        }

        // remove the lazy class when the full image is loaded to unblur
        source.addEventListener('load', () => {
            pictureTag.classList.remove("preview");
            window.dispatchEvent(new CustomEvent('imageLoaded', {}));
        }, false);

        // set a new srcset on the source elements
        if (source.tagName === 'SOURCE') {
            source.setAttribute("srcset", source.dataset.src);
        }
        // or a new src on the img element
        else {
            source.setAttribute("src", source.dataset.src);
        }
    }
}

const lazyload = (observerItems, observer)=> {
    observerItems.forEach(item => {
        if (item.isIntersecting) {
            lazyloadPicture(item.target);
            observer.unobserve(item.target);
        }
    });
};

const init = (image = null, customOptions = {}) => {
    if (window.IS_AUTOMATED_TESTING) {
        return
    }


    if (image === null) {
        throw new Error('please provide an lazyloading image class');
    }

    let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.0
    };

    Object.assign(options, customOptions);
    const observer = new IntersectionObserver(lazyload, options);

    if (typeof image === 'string') {
        const lazyImages = document.querySelectorAll(`.${image}`);

        lazyImages.forEach(picture => {
            observer.observe(picture);
        })
    } else {
        observer.observe(image)
    }
};

export default {
    init: init,
    lazyloadPicture: lazyloadPicture
};
